import Button from '@rio-cloud/rio-uikit/Button';
import FeedbackInlineButtons from '@rio-cloud/rio-uikit/FeedbackInlineButtons';
import { useState } from 'react';
import { StarRating } from 'react-flexible-star-rating';
import { FormattedMessage, useIntl } from 'react-intl';

// Reuse the same star configuration as the feedback modal.
const STARS_COUNT = 5;
const STAR_DIMENSION = 13;
const STAR_COLOR = '#fccc7c';

export const FeedbackBanner = () => {
    const intl = useIntl();
    const [isVisible, setIsVisible] = useState<boolean>(true);

    const handleDismiss = () => {
        setIsVisible(false);
    };

    const handleRatingChange = (rating: number) => {
        if (rating < 0) {
            return;
        }
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className='panel panel-default margin-top-5 margin-bottom-0' data-testid='feedback-banner'>
            <div className='display-flex align-items-center gap-15 padding-y-15 padding-x-20'>
                <FeedbackInlineButtons
                    headline={
                        <span className='text-color-dark'>
                            <FormattedMessage id='feedbackBanner.title' />
                        </span>
                    }
                    buttons={[
                        <div key='feedback-banner-stars' className='display-inline-flex'>
                            <StarRating
                                starsLength={STARS_COUNT}
                                dimension={STAR_DIMENSION}
                                color={STAR_COLOR}
                                onRatingChange={handleRatingChange}
                            />
                        </div>,
                    ]}
                />
                <div className='display-flex align-items-center gap-5 margin-left-auto'>
                    <Button
                        bsStyle={Button.PRIMARY}
                        variant={Button.VARIANT_LINK}
                        className='text-color-primary padding-x-5'
                        onClick={handleDismiss}
                        data-testid='feedback-banner-no-thanks'
                    >
                        <FormattedMessage id='feedbackBanner.noThanks' />
                    </Button>
                    <Button
                        bsStyle={Button.MUTED}
                        iconOnly
                        onClick={handleDismiss}
                        aria-label={intl.formatMessage({ id: 'general.close' })}
                        data-testid='feedback-banner-close'
                    >
                        <span className='uikit-icon icon-remove' />
                    </Button>
                </div>
            </div>
        </div>
    );
};
